import { useEffect, useState } from "react";

export default function ExternalVideoEmbed({ url }: { url: string }) {
  const [vidSrc, setVidSrc] = useState("");
  useEffect(() => {
    if (!url) return;

    let target = url;
    if (target.startsWith("https://youtu.be/")) {
      target = target.replace(
        "https://youtu.be/",
        "https://www.youtube.com/embed/"
      );
    }
    setVidSrc(target);
  }, [url]);
  return (
    <div className="relative" style={{ paddingBottom: "56.25%" }}>
      <iframe
        className="absolute top-0 left-0 w-full h-full"
        src={vidSrc}
      ></iframe>
    </div>
  );
}
